import * as TypeGraphQL from "type-graphql";
export var SortOrder;
(function (SortOrder) {
    SortOrder["asc"] = "asc";
    SortOrder["desc"] = "desc";
})(SortOrder || (SortOrder = {}));
TypeGraphQL.registerEnumType(SortOrder, {
    name: "SortOrder",
    description: undefined,
});
//# sourceMappingURL=SortOrder.js.map